// Guest drafts — items created before signing in.
//
// A signed-out user may create a small number of tasks / notes / events. They are kept here in
// localStorage (and committed into the normal store so they show in the UI). On sign-in they are
// pushed to the backend (see auth.service.js → syncGuestDrafts) and the subsequent fetch replaces
// the local copies with the real, server-side items.
//
// Limit is per TYPE: up to GUEST_LIMIT tasks AND GUEST_LIMIT notes AND GUEST_LIMIT events.

const KEY = 'busy:guestDrafts'
export const GUEST_LIMIT = 2

function read() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY))
    return Array.isArray(raw) ? raw : []
  } catch {
    return []
  }
}

function write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list))
  } catch {
    /* storage full / unavailable — nothing we can do here */
  }
}

/** How many drafts of this type the guest already has. */
export function guestCount(type) {
  return read().filter((d) => d.type === type).length
}

/** True while the guest is still under the per-type limit. */
export function canCreateAsGuest(type) {
  return guestCount(type) < GUEST_LIMIT
}

/** Record a draft; returns the local id assigned to it (used as the item's id in the store). */
export function addGuestDraft(type, payload) {
  const list = read()
  const id = `local-${type}-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`
  list.push({ id, type, payload })
  write(list)
  return id
}

export function getGuestDrafts() {
  return read()
}

/**
 * Mark the newest draft of this type as "created into a story": on sign-in it syncs as an entity
 * but does NOT spawn its own ongoing (its story already exists server-side under the guest id).
 */
export function markLastGuestDraftInStory(type) {
  const list = read()
  for (let i = list.length - 1; i >= 0; i--) {
    if (list[i].type === type) { list[i].inStory = true; break }
  }
  write(list)
}

export function clearGuestDrafts() {
  try {
    localStorage.removeItem(KEY)
  } catch {
    /* ignore */
  }
}
